import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  light?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  light = false
}: SectionHeadingProps) {
  return <div className={`${align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}`} data-id="element-210" data-mp="3k06xtxg0ixzu">
      {eyebrow && <p className="mb-2 text-xs font-bold uppercase tracking-[0.2em] text-safety" data-id="element-211" data-mp="bk3o7m5caz8v">
          {eyebrow}
        </p>}
      <h2 className={`font-display text-3xl font-bold uppercase leading-tight tracking-tight md:text-4xl ${light ? 'text-white' : 'text-ink'}`} data-id="element-212" data-mp="gix39j09yyb5">
        {title}
      </h2>
      {description && <p className={`mt-3 text-base leading-relaxed ${light ? 'text-steel-300' : 'text-steel-500'}`} data-id="element-213" data-mp="6rajgy9vfqws">
          {description}
        </p>}
    </div>;
}